<div class="grid">
    @if (filterOptions.showCameraFilter) {
        <div class="col-12 md:col-6 lg:col-2">
            <div class="text-center p-1">
                <p-select class="camera-dropdown" [options]="cameraList" [(ngModel)]="selectedCamera"
                    [style]="{'width':'100%'}" scrollHeight="350px" placeholder="Choose Camera"></p-select>
            </div>
        </div>
    }
    @if (filterOptions.showItemCodeFilter) {
        <div class="col-12 md:col-6 lg:col-2">
            <div class="text-center p-1 ">
                <p-select class="item-dropdown" [style]="{'width':'100%'}" [options]="itemCodes"
                    [(ngModel)]="selectedItemCode" scrollHeight="350px" placeholder="Item Code"></p-select>
            </div>
        </div>
    }
    @if (filterOptions.showDateRangeFilter) {
        <div class="col-12 md:col-6 lg:col-2">
            <div class="text-center p-1 ">
                <p-datepicker appDashboardRangeTime placeholder="Date Range" inputId="calendar-24h" [(ngModel)]="dateRange" selectionMode="range"
                    [fluid]="true" [showIcon]="true" [showButtonBar]="true" [iconDisplay]="'input'"
                    [showTime]="true" class="center-placeholder">
                </p-datepicker>

            </div>
        </div>
    }
    @if (filterOptions.showSearchParcel) {
        <div class="col-12 md:col-6 lg:col-2">
            <div class="text-center p-1 ">
                <p-iconField iconPosition="left" class="center-placeholder">
                    <input style="width: 100%;" type="text" pInputText placeholder="Search Parcel"
                        [(ngModel)]="searchParcel" />
                </p-iconField>
            </div>
        </div>
    }
    @if (filterOptions.showUserIdFilter) {
        <div class="col-12 md:col-6 lg:col-2">
            <div class="text-center p-1 ">
                <p-select [options]="userLists" [(ngModel)]="selectedUser" scrollHeight="350px"
                    placeholder="Filter By Assignee" [style]="{'width':'100%'}" [editable]="true" [filter]="true"
                    appendTo="body" [showClear]="true"></p-select>
            </div>
        </div>
    }
    @if (filterOptions.showApplyButton || filterOptions.showClearFilterButton) {
        <div class="col-12 md:col-6 lg:col-2">
            <div class="flex">
                <div class="p-1 ">
                    @if (filterOptions.showApplyButton) {
                        <p-button class=" p-1 primary-btn-bg" type="button" label="Apply"
                            (click)="applySearch()"></p-button>
                    }
                </div>
                <div class="p-1 ">
                    @if (filterOptions.showClearFilterButton && !showClear()) {
                        <p-button class=" p-1" type="button"
                            label="Clear" (click)="clearSearch()" [text]="true" severity="secondary"></p-button>
                    }
                </div>
            </div>
        </div>
    }
</div>